// *******************************************************
// Garden Export File
// -------------------------------------------------------
// All Background nad Foreground for the Garden Screen
// -------------------------------------------

// *******************************************
// Exports
// -------------------------------------------
export {default as Background} from './Background';
export {default as Foreground} from './Foreground';
// --------------------------------



// WEBPACK FOOTER //
// ./src/components/Background/Garden/index.js